import { ChangeEvent, FC, FormEvent, useState } from 'react'
import { InputFile } from './input-file'
import Loading from '../../../components/Loading'
import { DocumentsType } from './interface'

interface AddressProofProps {
    handleSubmit(document: DocumentsType): Promise<{ error: boolean }>
    setIsOpen(value: boolean): void
}

export const AddressProof: FC<AddressProofProps> = ({
    handleSubmit,
    setIsOpen,
}) => {
    const [documents, setDocuments] = useState<DocumentsType>({
        documentGroup: 'comprovante-endereco',
        files: [],
        numFilesRequired: 1,
    })
    const [isLoading, setIsLoading] = useState(false)

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        setIsLoading(true)
        const result = await handleSubmit(documents)
        setIsLoading(false)

        if (result.error === false) {
            setIsOpen(false)
        }
    }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]

        if (!file) return

        const newDocument = {
            docType: event.target.name, // Use o atributo 'name' para armazenar o tipo do documento
            file,
        }

        const filesFiltred = documents.files.filter(
            (item) => item.docType !== newDocument.docType
        )

        setDocuments((prevState) => ({
            ...prevState,
            files: [...filesFiltred, newDocument],
        }))
    }

    const addressProofDocument = documents.files.find(
        (document) => document.docType === 'comprovante-endereco'
    )

    if (isLoading) {
        return (
            <div className="flex items-center justify-center w-full">
                <Loading />
            </div>
        )
    }

    return (
        <form
            onSubmit={onSubmit}
            className="flex flex-col justify-between gap-4 mt-6 w-full"
        >
            <div className="flex-1 px-6">
                <InputFile
                    label="Comprovante de endereço"
                    document={addressProofDocument}
                    handleFileChange={handleFileChange}
                    name="comprovante-endereco"
                />
            </div>

            <div className="flex items-center justify-end gap-2 pb-6 px-6">
                <button
                    type="button"
                    onClick={() => setIsOpen(false)}
                    className="border border-black py-1 px-2 rounded-md h-8 flex items-center justify-center hover:bg-gray-400/20 transition ease-in duration-100 focus:ring-red-500 focus:ring-offset-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="py-1 px-2 flex items-center justify-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md h-8"
                >
                    Confirmar
                </button>
            </div>
        </form>
    )
}
